import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_ROOT } from "../service/Services";
import { useEffect } from "react";
import { IoDocuments, IoDocumentSharp, IoPeople, IoServerOutline } from "react-icons/io5";
import Spinner from "./Spinner";

export default function DashboardStatsGrid() {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({});

  const getTotals = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_ROOT}/totals`, {
        headers: { authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.data.success) {
        setStats(res.data);
      } else {
        setStats({});
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTotals();
  }, []);

  const boxes = [
    // {
    //   label: "Total Customers",
    //   value: stats.customerCount,
    //   icon: <IoPeople className="text-2xl text-white" />,
    //   bg: "bg-sky-500",
    //   onClick: () => navigation("/customers"),
    // },
    // {
    //   label: "Total Vendors",
    //   value: stats.vendorCount,
    //   icon: <IoServerOutline className="text-2xl text-white" />,
    //   bg: "bg-green-500",
    //   onClick: () => navigation("/vendors"),
    // },
    // {
    //   label: "Total G.R.N",
    //   value: stats.poCount,
    //   icon: <IoDocuments className="text-2xl text-white" />,
    //   bg: "bg-yellow-400",
    //   onClick: () => navigation("/purchase-orders"),
    // },
    // {
    //   label: "Total Items",
    //   value: stats.receivedPoCount,
    //   icon: <IoDocumentSharp className="text-2xl text-white" />,
    //   bg: "bg-pink-500",
    //   onClick: () => navigation("/All-items"),
    // },
  ];

  return (
    <div className="flex gap-4 flex-wrap">
      {loading && <Spinner />}
      {boxes.map((b, idx) => (
        <BoxWrapper key={idx}>
          <div className={`rounded-full h-12 w-12 flex items-center justify-center ${b.bg}`}>
            {b.icon}
          </div>
          <div
            className="pl-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md transition-colors"
            onClick={b.onClick}
          >
            <span className="text-sm text-gray-500 font-light">{b.label}</span>
            <div className="flex items-center">
              <strong className="text-xl text-gray-700 font-semibold">{b.value || 0}</strong>
            </div>
          </div>
        </BoxWrapper>
      ))}
    </div>
  );
}

function BoxWrapper({ children }) {
  return <div className="bg-white rounded-sm p-4 flex-1 border border-gray-200 flex items-center">{children}</div>;
}
